import React, { Component } from "react";
import axios from "axios";
import "../../App.css";
import { Sidebar } from "../../components/Sidebar";
import Banner from "./../../components/Banner";
import fileDownload from 'js-file-download'

const now = new Date();
const todayY = now.getFullYear();
const todayM = checkZero(now.getMonth() + 1);
const todayD = checkZero(now.getDate());
var date1 = todayY + "-" + todayM + "-" + todayD;
function checkZero(num) {
  return (num + "").length === 1 ? "0" + num : num;
}

const API = localStorage.getItem("assethost");

export default class ReportView extends Component {
  state = {
    id: 0,
    columns: [],
    rows: 0,
    filters: [],
    list: [],
    name: "",
    dataResult: "",
    dataList: 0,
    loader: false,
    startDate: new Date(date1 + " 00:00:00"),
    endDate: new Date(),
  };

  componentDidMount() {
    this.getList();
  }
  getList() {
    // this.setLoader(true)
    let search = window.location.search;
    let params = new URLSearchParams(search);
    let id = Number(params.get("id"));
     
       const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    axios
      .get(
       API +
          "/report/generatereportbyid/" +
          id +
          "/" +
          sessionStorage.getItem("roleId") +
          "/" +
          sessionStorage.getItem("individualProfileId") +
          "/" +
          sessionStorage.getItem("companyProfileId") +
          "/" +
          sessionStorage.getItem("lawEnforcementProfileId"),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(
        (res) => {
          //   this.setLoader(false)
          this.setState({
            filters: res.data.filters,
            id: id,
            name: res.data.name,
          });
        },
        (err) => {
          this.setState({ error: err + "" });
          //   this.props.setLoader(false);
        }
      );
  }
  search() {
    this.setLoader(true);

       const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    axios
      .post(
        API + "/report/getreportdata",
        this.getParameterData(""),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(
        (res) => {
          this.setLoader(false);
          this.setState({
            name: res.data.name,
            dataResult: res.data.dataResult,
            dataList: res.data.dataList,
          });
        },
        (err) => {
          this.setState({ error: err + "" });
          this.setLoader(false);
        }
      );
  }
  getParameterData(exportType) {
    var parameter1 = "";
    var parameter2 = "";
    var parameter3 = "";
    var parameter4 = "";
    var parameter5 = "";
    var parameter6 = "";
    var parameter7 = "";
    if (
      document.getElementById("parameter1") instanceof Object &&
      document.getElementById("parameter1") !== undefined
    ) {
      parameter1 = document.getElementById("parameter1").value;
    }
    if (
      document.getElementById("parameter2") instanceof Object &&
      document.getElementById("parameter2") !== undefined
    ) {
      parameter2 = document.getElementById("parameter2").value;
    }
    if (
      document.getElementById("parameter3") instanceof Object &&
      document.getElementById("parameter3") !== undefined
    ) {
      parameter3 = document.getElementById("parameter3").value;
    }
    if (
      document.getElementById("parameter4") instanceof Object &&
      document.getElementById("parameter4") !== undefined
    ) {
      parameter4 = document.getElementById("parameter4").value;
    }
    if (
      document.getElementById("parameter5") instanceof Object &&
      document.getElementById("parameter5") !== undefined
    ) {
      parameter5 = document.getElementById("parameter5").value;
    }
    if (
      document.getElementById("parameter6") instanceof Object &&
      document.getElementById("parameter6") !== undefined
    ) {
      parameter6 = document.getElementById("parameter6").value;
    }
    if (
      document.getElementById("parameter7") instanceof Object &&
      document.getElementById("parameter7") !== undefined
    ) {
      parameter7 = document.getElementById("parameter7").value;
    }
    return {
      individualProfileId: sessionStorage.getItem("individualProfileId"),
      roleId: sessionStorage.getItem("roleId"),
      companyProfileId: sessionStorage.getItem("companyProfileId"),
      lawEnforcementProfileId: sessionStorage.getItem("lawEnforcementProfileId"),
      fullname: sessionStorage.getItem("fullname"),
      parameterMapper: {
        parameter1: parameter1,
        parameter2: parameter2,
        parameter3: parameter3,
        parameter4: parameter4,
        parameter5: parameter5,
        parameter6: parameter6,
        parameter7: parameter7,
      },
      reportId: this.state.id,
      exportType: exportType,
    };
  }
  downloadExcel() {
    this.setLoader(true);

       const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${
        window.location.pathname + window.location.search
      }`;
      return;
    }
    axios
      .get(
        API +
          "/report/exportexcel/" +
          this.state.id +
          "/" +
          this.state.name +
          "/" +
          this.state.dataResult +
          "/" +
          sessionStorage.getItem("individualProfileId") +
          "/" +
          sessionStorage.getItem("companyProfileId") +
          "/" +
          sessionStorage.getItem("lawEnforcementProfileId"),
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((res) => {
        this.setLoader(false);
         fileDownload(res.data, this.state.name+".xlsx")
      });
  }
  processDates(startDate, endDate) {
    const now = new Date(startDate);
    const now1 = new Date(endDate);
    var date1 =
      now.getFullYear() +
      "-" +
      checkZero(now.getMonth() + 1) +
      "-" +
      checkZero(now.getDate()) +
      " " +
      checkZero(now.getHours()) +
      ":" +
      checkZero(now.getMinutes()) +
      ":" +
      checkZero(now.getMinutes());
    var date2 =
      now1.getFullYear() +
      "-" +
      checkZero(now1.getMonth() + 1) +
      "-" +
      checkZero(now1.getDate()) +
      " " +
      checkZero(now1.getHours()) +
      ":" +
      checkZero(now1.getMinutes()) +
      ":" +
      checkZero(now1.getMinutes());
    return date1 + "," + date2;
  }
  setLoader(loader) {
    this.setState({ loader: loader });
  }
  render() {
    let download = "";
    if (this.state.dataList > 0) {
      download = (
        <div className="d-flex gap-2 mb-4">
          <button
            className="btn btn-primary"
            title="Download Excel"
            onClick={() => {
              this.downloadExcel();
            }}
          >
            <i className="bi bi-file-earmark-spreadsheet-fill"></i> Excel
          </button>
        </div>
      );
    }

    let divMsg = null;
    if (this.state.msg) {
      divMsg = (
        <div
          className={
            this.state.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {this.state.msg}
        </div>
      );
    }

    let loaderDiv = null;
    if (this.state.loader) {
      loaderDiv = (
        <div id="loader" className="loader-overlay">
          <div align="center" className="loader"></div>
        </div>
      );
    }

    // Parse report data for table display
    let reportData = [];
    let columns = [];
    try {
      if (this.state.dataResult) {
        const parsedData = JSON.parse(this.state.dataResult);
        if (
          parsedData &&
          Array.isArray(parsedData.data) &&
          parsedData.data.length > 0
        ) {
          reportData = parsedData.data;
          columns = parsedData.columns || Object.keys(parsedData.data[0] || {});
        }
      }
    } catch (e) {
      console.error("Error parsing report data:", e);
    }

    return (
      <div className="min-vh-100 h-dvh d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 d-flex flex-column flex-grow-1">
          <Banner title="View Report" withIcons={true} />

          {divMsg}

          <div className="w-100 flex-grow-1 px-5 h-60 d-flex flex-column">
            {/* Filters Section */}
            <div className="bg-white p-4 rounded-3 shadow-sm mb-4">
              <div className="row g-4 align-items-end">
                {this.state.filters.map((filter, index) => (
                  <div key={index} className="col-span-3">
                    <div className="input-group">
                      <label className="input-group-text">{filter.label}</label>
                      {filter.filterType === "DATE_RANGE" ? (
                        <div className="d-flex gap-2">
                          <input
                            type="datetime-local"
                            id={filter.parameterName}
                            className="form-control"
                            defaultValue={this.processDates(
                              this.state.startDate,
                              this.state.endDate
                            )}
                          />
                        </div>
                      ) : (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: filter.inputField,
                          }}
                        />
                      )}
                    </div>
                  </div>
                ))}
                <div className="col-span-1">
                  <button
                    className="btn btn-primary w-full"
                    onClick={() => this.search()}
                  >
                    <i className="bi bi-search"></i> Search
                  </button>
                </div>
              </div>
            </div>

            {/* Download buttons */}
            {download}

            {/* Report Data Table */}
            {reportData.length > 0 ? (
              <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                <table className="table table-striped table-hover rounded">
                  <thead className="bg-light sticky-top">
                    <tr>
                      {columns.map((column, index) => (
                        <th
                          key={index}
                          className="px-6 py-3 text-start text-xs fw-medium text-muted text-uppercase"
                        >
                          {column}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200">
                    {reportData.map((row, rowIndex) => (
                      <tr key={rowIndex} className="hover:bg-gray-50">
                        {columns.map((column, colIndex) => (
                          <td
                            key={colIndex}
                            className="px-6 py-4 text-nowrap text-sm text-dark"
                          >
                            {row[column] || "-"}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-muted text-center py-8">
                {this.state.dataResult
                  ? "No data available for this report."
                  : "Use the search form above to generate report data."}
              </div>
            )}

            {loaderDiv}
          </div>
        </div>
      </div>
    );
  }
}
